/* unplugin-vue-components disabled */import { render } from "./lockRelateOrderList.vue?vue&type=template&id=701cadf7&scoped=true"
import script from "./lockRelateOrderList.vue?vue&type=script&lang=js"
export * from "./lockRelateOrderList.vue?vue&type=script&lang=js"

import "./lockRelateOrderList.vue?vue&type=style&index=0&id=701cadf7&scoped=true&lang=less"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-701cadf7"]])

export default __exports__